export default {
  // 搜索相关
  searchPlaceholder: "搜索地址/哈希/调证用户ID",
  dataDetails: "数据详情",

  // 页面标题
  addressDetails: "地址详情",
  contractDetails: "合约详情",

  // 按钮
  joinCanvas: "加入画布",
  multiCurrencyCanvas: "多币种画布",
  singleCurrencyCanvas: "单币种画布",
  joinMonitor: "加入监控",
  browserView: "浏览器查看",

  // 对话框
  addMonitorTitle: "添加监控",

  // 消息提示
  copySuccess: "复制成功",
  addressNotFound: "没有查出该地址",
  traceabilityDialog: {
    title: "溯源",
    strategyName: "策略名称",
    strategyId: "策略编号",
    strategyRunTime: "策略运行时间",
    dependency: "依赖",
    hitRules: "命中规则",
  },
  missingTagDialog: {
    title: "标签缺失",
    addressLabel: "地址",
    missingTagLabel: "缺失标签",
    missingTagPlaceholder: "请选择缺失标签",
    platformCnLabel: "平台中文名称",
    platformCnPlaceholder: "请选择平台中文名称",
    reasonLabel: "缺失原因",
    reasonPlaceholder: "请输入缺失原因",
    cancel: "取消",
    confirm: "确认",
    addressEmpty: "地址为空",
    missingTagEmpty: "请选择缺失标签",
    platformCnEmpty: "请选择平台中文名称",
    reasonEmpty: "请输入缺失原因",
    success: "添加成功",
  },
  correctionDialog: {
    title: "纠错",
    tagNameLabel: "标签名称",
    tagNamePlaceholder: "请输入标签名称",
    errorTypeLabel: "错误类型",
    errorTypePlaceholder: "请选择错误类型",
    errorReasonLabel: "错误原因",
    errorReasonPlaceholder: "请输入错误原因",
    cancel: "取消",
    confirm: "确认",
    tagNameEmpty: "请输入标签名称",
    errorTypeEmpty: "请选择错误类型",
    errorReasonEmpty: "请输入错误原因",
    success: "提交成功",
  },

  // 交易对手相关
  rival: {
    // 搜索表单
    dataSource: "数据来源",
    transactionDirection: "交易方向",
    currency: "币种",
    counterpartyPlaceholder: "请输入交易对手地址",
    pleaseSelect: "请选择",
    totalAmount: "总数量",
    transactionCount: "交易次数",
    minAmount: "最小数量",
    maxAmount: "最大数量",
    maxAmountValidation: "最大数量需≥最小数量",
    reset: "重置",
    search: "查询",
    
    // 数据统计
    totalData: "共计",
    dataCount: "条数据",
    
    // 加载
    loading: "拼命加载中",
    
    // 表格列
    direction: "交易方向",
    counterparty: "交易对手",
    count: "交易次数",
    totalQuantity: "交易总数量",
    
    // 交易方向选项
    inflow: "充币",
    outflow: "提币",
    
    // 数据来源选项
    onChainData: "链上数据",
    platformInternal: "平台内部",
    
    // 空数据提示
    emptyText: "当前调证文件中未解析到充提交易数据",
    
    // 下载
    downloadDetails: "下载数据明细",
  },
};
